// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__EnH6X","canvas":"index_canvas___I4WI"};